import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ConstructionLogSection from './components/ConstructionLogSection';
import { SITE_URL, useSeo } from '../../lib/seo';

export default function WakuwakuStudioLogPage() {
  useSeo({
    title: 'WakuWaku Studio. 工事記録 | 防音スタジオができるまで | 合同会社WakuWaku',
    description:
      '大阪・箕面市の防音スタジオができるまでの記録。何もない部屋が音の拠点になっていく過程を写真と動画で紹介します。',
    path: '/wakuwaku-studio-log/',
    keywords: '防音スタジオ,スタジオ建設,録音スタジオ 大阪,MA制作スタジオ,箕面市,WakuWaku Studio,工事記録',
  });

  useEffect(() => {
    const siteUrl = SITE_URL;
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${siteUrl}/wakuwaku-studio-log/#webpage`,
      url: `${siteUrl}/wakuwaku-studio-log/`,
      name: 'WakuWaku Studio. 工事記録 | 合同会社WakuWaku',
      description: '大阪・箕面市の防音スタジオができるまでの記録。何もない部屋が音の拠点になっていく過程を写真で紹介します。',
      inLanguage: 'ja',
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-studio';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById('schema-studio');
      if (el) document.head.removeChild(el);
    };
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <Header />
      <ConstructionLogSection />
      <Footer />
    </div>
  );
}
